var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.04459H19C19.2652 2.04459 19.5196 2.14994 19.7071 2.33748C19.8946 2.52502 20 2.77937 20 3.04459V19.0446C20 19.3098 19.8946 19.5642 19.7071 19.7517C19.5196 19.9392 19.2652 20.0446 19 20.0446H1C0.734784 20.0446 0.48043 19.9392 0.292893 19.7517C0.105357 19.5642 0 19.3098 0 19.0446V3.04459C0 2.77937 0.105357 2.52502 0.292893 2.33748C0.48043 2.14994 0.734784 2.04459 1 2.04459H5V0.0445862H7V2.04459H13V0.0445862H15V2.04459ZM2 8.04459V18.0446H18V8.04459H2ZM4 10.0446H6V12.0446H4V10.0446ZM4 14.0446H6V16.0446H4V14.0446ZM8 10.0446H16V12.0446H8V10.0446ZM8 14.0446H13V16.0446H8V14.0446Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/Schedule-icon.573602d4a41c8c14c729b32e31e10854.svg";
export { ForwardRef as ReactComponent };